import React from 'react';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';


const StanceBeamBarChart = ({ chartData, barColor }) => (

    <ResponsiveContainer width="100%" height={200}>
        <BarChart data={chartData}
            margin={{ top: 10, right: 0, left: -25, bottom: 0 }}>
            <XAxis dataKey="x" />
            <YAxis />
            <CartesianGrid strokeDasharray="0 3" />
            <Tooltip />
            {/* <Legend /> */}
            {/* <Bar dataKey="pv" fill="#3367d6" /> */}
            <CartesianGrid
                vertical={false}
            />
            <Bar dataKey={Object.keys(chartData[0])[1]} fill={barColor} />
            {/* <Bar dataKey="Max Bat Speed" fill={barColor} /> */}
        </BarChart>
    </ResponsiveContainer>
);

export default StanceBeamBarChart;